// PDP Status Constants
export const PDP_STATUS_DRAFT = 'draft';
export const PDP_STATUS_SUBMITTED = 'submitted';
export const PDP_STATUS_ACTIVE = 'active';
export const PDP_STATUS_COMPLETED = 'completed';
export const PDP_STATUS_ARCHIVED = 'archived';

// Related Area Enum
export enum RelatedArea {
  EXPERTISE = 'expertise',
  CONSULTANCY = 'consultancy',
  LEADERSHIP = 'leadership',
}

// PDP Status Color Mapping (matching scorecard pattern)
export const getPDPStatusColor = (status: string) => {
  switch (status) {
    case PDP_STATUS_DRAFT:
      return '#f0f0f0'; // Light gray
    case PDP_STATUS_SUBMITTED:
      return '#e3f2fd'; // Light blue
    case PDP_STATUS_ACTIVE:
      return '#e8f5e8'; // Light green
    case PDP_STATUS_COMPLETED:
      return '#f3e5f5'; // Light purple
    case PDP_STATUS_ARCHIVED:
      return '#fafafa'; // Very light gray
    default:
      return '#f0f0f0';
  }
};

// Motivation Factor Constants
export enum MotivationFactor {
  COMPENSATION = 'compensation',
  TEAM_OF_TRUST = 'team_of_trust',
  TEAM_OF_PROFESSIONALS = 'team_of_professionals',
  WORK_ENVIRONMENT = 'work_environment',
  WELL_STRUCTURED_ENVIRONMENT = 'well_structured_environment',
  RECOGNITION = 'recognition',
  CHALLENGE = 'challenge',
  POWER_IMPACT = 'power_impact',
  CHANGES = 'changes',
  CREATIVITY_AUTONOMY = 'creativity_autonomy',
  SELF_DEVELOPMENT_GROWTH = 'self_development_growth',
  USEFUL_MEANINGFUL_JOB = 'useful_meaningful_job',
}
